import type { AdminUserRole } from '../backend/main';
import type { MenuItem } from './layout/main-menu-config.type';

export const TOP_RIGHT_MENU_CONFIG: MenuItem<AdminUserRole>[] = [
  {
    name: 'my-profile',
    label: 'PROFILE_MENU.MY_PROFILE',
    routeLink: 'my-profile',
    icon: 'pct-mdi-account',
    role: ['SystemAdmin', 'Admin'],
  },
];
